import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, Package, Clock } from 'lucide-react';

const OrderSuccess = () => {
  const { id } = useParams();
  return (
    <div className="max-w-md mx-auto p-8 text-center">
      <div className="w-20 h-20 rounded-full bg-green-100 text-green-600 flex items-center justify-center mx-auto">
        <CheckCircle2 size={44} />
      </div>
      <h1 className="text-2xl font-bold text-[#0B2E5C] mt-4">Order Placed!</h1>
      <p className="text-sm text-gray-500 mt-1">Your food is being prepared and will be delivered to your seat.</p>
      <div className="bg-white border border-gray-100 rounded-xl p-4 card-shadow mt-5 text-left">
        <div className="text-xs text-gray-500">Order ID</div>
        <div className="font-mono font-bold text-[#0B2E5C]">{id?.slice(0,8).toUpperCase()}</div>
        <div className="mt-3 flex items-center gap-2 text-sm text-amber-700"><Clock size={14} /> Expected delivery in 30-45 minutes</div>
      </div>
      <div className="flex gap-3 mt-5">
        <Link to="/my-orders" className="flex-1 bg-tp-navy text-white font-semibold py-2.5 rounded-lg hover:opacity-90">Track Order</Link>
        <Link to="/food-on-train" className="flex-1 bg-tp-orange text-white font-semibold py-2.5 rounded-lg hover:bg-[#E07A0F]">Order More</Link>
      </div>
    </div>
  );
};

export default OrderSuccess;
